/* eslint-disable */
import store from './store'

let dictionary
store.ready().then(() => {
  dictionary = store.get('dictionary') || {}
})

export default {
  has: (languagePair, text) => {
    text = (text || '').toLowerCase()
    dictionary[languagePair] = dictionary[languagePair] || {}
    
    return dictionary[languagePair][text] != undefined
  },
  
  add: (languagePair, text, translation) => {
    text = text.toLowerCase()
    dictionary[languagePair] = dictionary[languagePair] || {}
    
    dictionary[languagePair][text] = { translation }
    store.set('dictionary', dictionary)
  },
  
  remove: (languagePair, text) => {
    text = text.toLowerCase()
    dictionary[languagePair] = dictionary[languagePair] || {}
    
    delete dictionary[languagePair][text]
    store.set('dictionary', dictionary)
  },
  
  get: (languagePair, text) => {
    text = text.toLowerCase()
    dictionary[languagePair] = dictionary[languagePair] || {}
    
    return dictionary[languagePair][text]
  },
  
  list: (languagePair) => {
    return Object.keys(dictionary[languagePair] || {}).map(text => ({
      original: text,
      translated: dictionary[languagePair][text],
    }))
  },
}